import React, { useContext } from 'react';
import Image from 'next/image';
import { useTheme } from 'styled-components';
import { ThemeContext } from 'theme';
import { useTranslation } from 'react-i18next';

import { AppStore, GooglePlay } from 'public/assets/icons';
import {
  CardWrapper,
  AppWrapper,
  EventWrapper,
  SVGWrapper,
  GetAppTitle,
  Texts,
  DownloadContainer,
  DownloadButton,
  DownloadButtonWrap,
  ImageMockup,
  ImageEventCard,
} from './styles';

const AppsBannerLanding = () => {
  const theme: any = useTheme();
  const context: any = useContext(ThemeContext);
  const { t } = useTranslation();
  return (
    <CardWrapper>
      <AppWrapper>
        <GetAppTitle type="h1">
          {t('landing:bottomfooter:getRoadStr')}
        </GetAppTitle>
        <Texts>{t('landing:bottomfooter:getRoadStrText')}</Texts>
        <DownloadContainer>
          <DownloadButtonWrap>
            <DownloadButton path={context.content.playStore}>
              <GooglePlay />
            </DownloadButton>
          </DownloadButtonWrap>
          <DownloadButtonWrap>
            <DownloadButton path={context.content.appStore}>
              <AppStore />
            </DownloadButton>
          </DownloadButtonWrap>
        </DownloadContainer>
      </AppWrapper>
      <EventWrapper>
        <SVGWrapper height="460" width="460">
          <ellipse
            cx="230"
            cy="230"
            rx="230"
            ry="230"
            style={{ fill: theme.colors.orange }}
          />
          <ellipse
            cx="230"
            cy="230"
            rx="190"
            ry="190"
            style={{ fill: theme.colors.orangeLight }}
          />
          <ellipse
            cx="230"
            cy="230"
            rx="170"
            ry="170"
            style={{ fill: theme.colors.orange }}
          />
          <ellipse
            cx="230"
            cy="230"
            rx="140"
            ry="140"
            style={{ fill: theme.colors.orangeLight }}
          />
          <ellipse
            cx="230"
            cy="230"
            rx="120"
            ry="120"
            style={{ fill: theme.colors.orange }}
          />
          <ellipse
            cx="230"
            cy="230"
            rx="100"
            ry="100"
            style={{ fill: theme.colors.orangeLight }}
          />
        </SVGWrapper>
        <ImageMockup>
          <Image
            src="/assets/img/spaceblackmockup.svg"
            height="100%"
            width="100%"
            unoptimized
            priority
          />
        </ImageMockup>
        <ImageEventCard>
          {process.env._ENV === 'rockr' ? (
            <Image
              src="/assets/img/eventscardrockr.svg"
              height="100%"
              width="100%"
              unoptimized
              priority
            />
          ) : (
            <Image
              src="/assets/img/eventscardroadstr.svg"
              height="100%"
              width="100%"
              unoptimized
              priority
            />
          )}
        </ImageEventCard>
      </EventWrapper>
    </CardWrapper>
  );
};

export default AppsBannerLanding;
